/* AJ-PACKAGING-C2-V2 — gift-box selector behaviour (see snippets/d5-addons.liquid) */
(function () {
  if (customElements.get('aj-packaging')) return;

  class AjPackaging extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.$ = (s) => this.querySelector(s);
      this.$$ = (s) => Array.prototype.slice.call(this.querySelectorAll(s));
      this.t = this.dataset;

      this.propInput = this.$('[data-ajp-prop]');
      this.cardInput = this.$('[data-ajp-card]');
      this.lineInput = this.$('[data-ajp-line]');
      this.closedEl = this.$('[data-ajp-closed]');
      this.pickerEl = this.$('[data-ajp-picker]');
      this.openBtn = this.$('[data-ajp-open]');

      var firstLeather = this.$('[data-ajp-swatches="leather"] [data-ajp-colour][aria-pressed="true"]') ||
        this.$('[data-ajp-swatches="leather"] [data-ajp-colour]');
      // Committed choice (what goes to the cart)
      this.committed = { type: firstLeather ? 'leather' : 'premium', el: firstLeather };
      this.lastLeather = firstLeather;
      // Draft choice while the picker is open
      this.draft = null;

      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !this.pickerEl.hidden) this.closePicker(true);
      });

      var nameInput = this.$('[data-ajp-name-input]');
      if (nameInput) {
        nameInput.addEventListener('input', () => this.onName(nameInput));
        nameInput.addEventListener('focus', () => this.keepVisible(nameInput));
      }

      this.attachToForm();
      try { this.prices = JSON.parse(this.$('[data-ajp-prices]').textContent); } catch (e) { this.prices = {}; }
      var schedule = () => requestAnimationFrame(() => this.updateTotal());
      document.addEventListener('change', schedule);
      document.addEventListener('click', () => setTimeout(schedule, 60));
      document.addEventListener('input', schedule);
      if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(schedule, 60));
      this.renderClosed();
    }

    /* "Add to cart · AED 424" = (piece + chosen box) x quantity */
    updateTotal() {
      if (!this.form) return;
      var btn = this.form.querySelector('.product-form__submit');
      var label = btn && btn.querySelector('span');
      if (!btn || !label || btn.disabled) return;
      var idInput = this.form.querySelector('[name="id"]');
      var piece = this.prices[idInput && idInput.value];
      if (piece == null) return;
      var box = Number((this.committed.el && this.committed.el.dataset.price) || 0);
      var qtyInput = this.form.querySelector('[name="quantity"]') || document.querySelector('input[name="quantity"][form="' + this.form.getAttribute('id') + '"]');
      var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      var total = ((piece + box) * qty) / 100;
      var amount = total % 1 === 0 ? total.toLocaleString('en-US') : total.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      if (!this.baseLabel || label.dataset.ajpTotal !== label.textContent) this.baseLabel = label.textContent.split(' · ')[0].trim();
      var text = this.baseLabel + ' · AED ' + amount;
      label.textContent = text;
      label.dataset.ajpTotal = text;
    }

    /* Link the hidden inputs to the product form so Add to cart AND Apple Pay / Google Pay carry them */
    attachToForm() {
      var scope = this.closest('.product__info-container') || this.closest('section') || document;
      var form = scope.querySelector('form[data-type="add-to-cart-form"]') || document.querySelector('form[data-type="add-to-cart-form"]');
      // NB: form.id would return the <input name="id"> inside Shopify forms, so read the attribute.
      var formId = form && form.getAttribute('id');
      if (!formId) return;
      this.form = form;
      [this.propInput, this.cardInput].forEach((i) => i && i.setAttribute('form', formId));
      this.buttons = form.querySelector('.product-form__buttons');
    }

    swatches(type) {
      return this.$$('[data-ajp-swatches="' + type + '"] [data-ajp-colour]');
    }

    boxName(type, el) {
      if (!el) return (type === 'premium' ? this.t.tPname : this.t.tLname) + ' Box';
      return el.dataset.name + ' ' + (type === 'premium' ? this.t.tPname : this.t.tLname) + ' Box';
    }

    onClick(e) {
      var b = e.target.closest('button');
      if (!b || !this.contains(b)) return;

      if (b.hasAttribute('data-ajp-open')) return this.openPicker(this.committed.type);
      if (b.hasAttribute('data-ajp-upgrade')) return this.openPicker('premium');
      if (b.hasAttribute('data-ajp-undo')) {
        this.commit('leather', this.lastLeather || this.swatches('leather')[0]);
        this.openBtn.focus();
        return;
      }
      if (b.hasAttribute('data-ajp-close')) return this.closePicker(true);
      if (b.hasAttribute('data-ajp-type')) {
        this.draft.type = b.dataset.ajpType;
        return this.renderPicker();
      }
      if (b.hasAttribute('data-ajp-colour')) {
        this.draft[this.draft.type] = b;
        return this.renderPicker();
      }
      if (b.hasAttribute('data-ajp-confirm')) {
        var el = this.draft[this.draft.type];
        if (!el) return; // premium colour not picked yet — never auto-pick
        this.commit(this.draft.type, el);
        this.closePicker(true);
        return;
      }
      if (b.hasAttribute('data-ajp-gift')) return this.toggleGift(b);
    }

    openPicker(type) {
      this.draft = {
        type: type,
        leather: this.committed.type === 'leather' ? this.committed.el : this.lastLeather,
        premium: this.committed.type === 'premium' ? this.committed.el : null
      };
      this.closedEl.hidden = true;
      this.pickerEl.hidden = false;
      this.openBtn.setAttribute('aria-expanded', 'true');
      this.renderPicker();
      var first = this.$('[data-ajp-type][aria-pressed="true"]') || this.$('[data-ajp-close]');
      if (first) first.focus({ preventScroll: true });
    }

    closePicker(returnFocus) {
      this.draft = null;
      this.pickerEl.hidden = true;
      this.closedEl.hidden = false;
      this.openBtn.setAttribute('aria-expanded', 'false');
      if (returnFocus) this.openBtn.focus({ preventScroll: true });
    }

    renderPicker() {
      var d = this.draft;
      var type = d.type;
      var el = d[type];
      var needColour = type === 'premium' && !el;

      this.$$('[data-ajp-type]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.ajpType === type)));
      this.$$('[data-ajp-swatches]').forEach((g) => (g.hidden = g.dataset.ajpSwatches !== type));
      this.swatches(type).forEach((s) => s.setAttribute('aria-pressed', String(s === el)));

      var shown = el || this.swatches(type)[0];
      var stage = this.$('[data-ajp-stage]');
      if (shown && shown.dataset.img) {
        stage.src = shown.dataset.img;
        stage.alt = this.boxName(type, shown);
        stage.hidden = false;
      }
      this.$('[data-ajp-stagewrap]').classList.toggle('ajp__stage--dark', type === 'premium');
      this.$('[data-ajp-caption]').textContent = type === 'premium' ? this.t.tPcap : this.t.tLcap;
      this.$('[data-ajp-colournote]').textContent = el ? '· ' + el.dataset.name : '';

      var confirm = this.$('[data-ajp-confirm]');
      confirm.textContent = needColour ? this.t.tPrompt : this.t.tConfirm + ' · ' + this.boxName(type, el);
      confirm.setAttribute('aria-disabled', String(needColour));
    }

    commit(type, el) {
      if (!el) return;
      this.committed = { type: type, el: el };
      if (type === 'leather') this.lastLeather = el;
      this.renderClosed();
    }

    renderClosed() {
      var c = this.committed;
      var el = c.el;
      if (!el) return;
      var premium = c.type === 'premium';

      this.$('[data-ajp-label]').textContent = premium ? this.t.tPrem : this.t.tFree;
      this.$('[data-ajp-name]').textContent = this.boxName(c.type, el);
      this.$('[data-ajp-price]').textContent = premium ? this.t.tPsub : this.t.tIncluded;
      var thumb = this.$('[data-ajp-thumb]');
      if (thumb && el.dataset.thumb) {
        thumb.src = el.dataset.thumb;
        thumb.hidden = false;
      }
      this.$('[data-ajp-closed]').classList.toggle('ajp__closed--premium', premium);
      var up = this.$('[data-ajp-upgrade]');
      var added = this.$('[data-ajp-added]');
      if (up) up.hidden = premium;
      if (added) added.hidden = !premium;

      // Cart values
      this.propInput.value = el.dataset.title;
      this.lineInput.value = el.dataset.variant;

      this.syncExpress(premium);
      this.updateTotal();
    }

    /* Apple Pay / Google Pay cannot carry the paid box line, so (optionally) hide them while Premium is chosen */
    syncExpress(premium) {
      if (!this.buttons) this.attachToForm();
      if (!this.buttons) return;
      var hide = premium && this.dataset.hideExpress === 'true';
      this.buttons.classList.toggle('ajp-no-express', hide);
      var note = this.buttons.querySelector('.ajp-express-note');
      if (hide && !note) {
        note = document.createElement('p');
        note.className = 'ajp-express-note';
        note.textContent = this.t.tExpress;
        this.buttons.appendChild(note);
      }
      if (note) note.hidden = !hide;
    }

    toggleGift(btn) {
      var on = btn.getAttribute('aria-checked') !== 'true';
      btn.setAttribute('aria-checked', String(on));
      this.$('[data-ajp-namefield]').hidden = !on;
      var input = this.$('[data-ajp-name-input]');
      if (on && input) input.focus();
      this.syncCard();
    }

    /* Mobile: keep the name field above the on-screen keyboard (iOS Safari / Chrome) */
    keepVisible(input) {
      var run = () => {
        if (document.activeElement !== input) return;
        var vv = window.visualViewport;
        var top = vv ? vv.offsetTop : 0;
        var height = vv ? vv.height : window.innerHeight;
        var r = input.getBoundingClientRect();
        if (r.top >= top + 90 && r.bottom <= top + height - 24) return; // already fully visible
        var delta = (r.top + r.height / 2) - (top + height * 0.4);
        window.scrollBy({ top: delta, behavior: 'smooth' });
      };
      [150, 400, 750].forEach((t) => setTimeout(run, t));
      if (window.visualViewport && !this._vvBound) {
        this._vvBound = true;
        window.visualViewport.addEventListener('resize', () => setTimeout(run, 60));
      }
    }

    onName(input) {
      var clean = input.value.replace(/[<>]/g, '').slice(0, 14);
      if (clean !== input.value) input.value = clean;
      this.$('[data-ajp-count]').textContent = clean.length + '/14';
      this.syncCard();
    }

    syncCard() {
      var on = this.$('[data-ajp-gift]').getAttribute('aria-checked') === 'true';
      var name = (this.$('[data-ajp-name-input]').value || '').trim();
      this.cardInput.value = on ? name : '';
      this.cardInput.disabled = !(on && name);
    }
  }

  customElements.define('aj-packaging', AjPackaging);
})();
